require('./loanModifyAssociatedAccountView.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require("react-router-dom");
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { getLastNChars } = require('utilities/stringHelper');
const { hasAllAccountsInactiveAndNegativeBalance } = require('utilities/currentAccountsHelper');
// @ commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const WizardError = require('components/commons/wizardError/wizardError');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const LoanHeader = require('../../components/loansAndMortgages/loans/loanHeader/loanHeader');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
// @ components
const LoanModifyAssociatedAccountStep1 = require('../../components/loansAndMortgages/loanModifyAssociatedAccountSteps/loanModifyAssociatedAccountStep1/loanModifyAssociatedAccountStep1');
const LoanModifyAssociatedAccountStep2 = require('../../components/loansAndMortgages/loanModifyAssociatedAccountSteps/loanModifyAssociatedAccountStep2/loanModifyAssociatedAccountStep2');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const LoansBlockedAccountsMessage = require('../../components/loansAndMortgages/loansBlockedAccountsMessage/loansBlockedAccountsMessage');
// @ actions
const collectiveActions = require('actions/collectives');
const loanModifyAssociatedAccountActions = require('../../actions/loanModifyAssociatedAccount');
const blockedAccountsActions = require('actions/blockedAccounts');
// @ constants
const {
    BANK_PHONE_NUMBER_CLIENTS_ONLY_1,
    ACCOUNT_INTERVENTION_OWNER,
    GRAPHIC_TUTOR_TYPE_4,
    MULTICHANNEL_UI_COMPONENT
} = require('constants/index');

class LoanModifyAssociatedAccountView extends React.Component {
    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
        this.handleNewAccount = this.handleNewAccount.bind(this);
        this.setVisibleStep = this.setVisibleStep.bind(this);
        this.validateStep = this.validateStep.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        const { match: {params: { loanId }}, immLoans, immAccounts, modifyFailure, getCollectiveInfo } = this.props;
        const immLoan = immLoans.getIn(['byId', loanId], false);

        if (immLoan && !immLoan.get('isOldLoan') && !immLoan.get('isRestrictedLoan')) {
            const immAccount = this.getCurrentAccount(immLoan, immAccounts);
            const productType = {
                type: immLoan.get('product'),
                subType: immLoan.get('productSubType'),
                standard: immLoan.get('productStandard')
            };

            if (immAccount) {
                this.checkAccounts(immAccount);
                getCollectiveInfo([productType], MULTICHANNEL_UI_COMPONENT);
            } else {
                // If no user account matches with loan account, we show error
                modifyFailure({ error: true });
            }
        } else {
            this.props.history.push('/myprofile/loans-mortgages');
        }
    }

    componentWillUnmount() {
        this.props.reset();
    }

    checkAccounts(immAccount) {
        const { match: {params: { loanId }}, immAccounts, setAccountsInactive, setCurrentAccount } = this.props;

        const accountsMap = immAccounts.get('byId');
        const accountsList = this.getAccountsList(immAccounts.get('byOrder').toJS(), accountsMap, immAccount);

        const accountsInactive = hasAllAccountsInactiveAndNegativeBalance(accountsList, accountsMap);

        if (accountsInactive) {
            setAccountsInactive();
        } else {
            setCurrentAccount({
                response: { currentAccountId: immAccount.get('accountId'), loanId }
            });
        }
    }

    getAccountsList(accounts, accountsMap, immCurrentAccount) {
        return accounts.filter(accountId => {
            const accountHolder = accountsMap.getIn([accountId, 'interventionType']);
            const accountProduct = accountsMap.getIn([accountId, 'newProduct']);
            return immCurrentAccount.get('accountId') !== accountId && accountHolder === ACCOUNT_INTERVENTION_OWNER && accountProduct === '300' // CUENTA CORRIENTE
        });
    }

    getAliasUrl(immLoan) {
        return `/myprofile/loans-mortgages/preapproved-loans/${immLoan.get('loanId')}`;
    }

    getCurrentAccount(immLoan, immAccounts) {
        const immAccountsByOrder = immAccounts.get('byOrder');
        const immLoanTrim = immLoan.get('account').trim();
        const loanAccountId = immAccountsByOrder.find(accountId => {
            return immAccounts.getIn(['byId', accountId, 'ibanComplex', 'codbban']) === immLoanTrim;
        });
        return immAccounts.getIn(['byId', loanAccountId]);
    }

    setVisibleStep(currentStep) {
        this.props.setVisibleStep({ currentStep });
    }

    validateStep(currentStep) {
        this.props.validateStep({ currentStep });
    }

    buildBreadcrum(immLoan) {
        return [
            {
                text: formatText('breadcrumb-loansAndMortgages'),
                url: `/myprofile/loans-mortgages`
            },
            {
                text: immLoan.get('alias'),
                url: this.getAliasUrl(immLoan)
            },
            {
                text: formatText('breadcrumb-loanModifyAssociatedAccount')
            }
        ];
    }

    buildError() {
        const { immGlobalVariables } = this.props;
        const errorMessage = formatText('loanModifyAssociatedAccount-errorMessage');
        const goBackButton = {
            label: <FormattedText value="loanModifyAssociatedAccount-goBackButton" format="uppercase" />,
            url: '/myprofile/loans-mortgages'
        };
        const phoneNumber = immGlobalVariables.getIn([ 'variables', 'parameters', 'telefono', 'cliente' ]);

        return (
            <WizardError
                errorMessage={errorMessage}
                mainButton={goBackButton}
            >
                <section className="row no-gutter">
                    <FormattedText value="loanModifyAssociatedAccount-errorSubmessage" />
                    <div className="loan-modify-associated-account-view__error-icons">
                        <i className="icon icon-s-llamar"></i>
                        <span>
                            {phoneNumber}
                        </span>
                        <i className="icon icon-s-llamar loan-modify-associated-account-view__error-icons--separate"></i>
                        <span>
                            {BANK_PHONE_NUMBER_CLIENTS_ONLY_1}
                        </span>
                    </div>
                </section>
            </WizardError>
        );
    }

    buildInactiveAccounts() {
        return (
            <LoansBlockedAccountsMessage />
        )
    }

    buildInsuficientAccounts() {
        const primaryText = formatText('loanModifyAssociatedAccount-warningMessage');
        const linkText = formatText('loanModifyAssociatedAccount-goBackButton');
        const linkURL = '/myprofile/loans-mortgages';

        return (
            <OKSectionBox>
                <EmptyState
                    primaryText={primaryText}
                    linkText={linkText}
                    linkURL={linkURL}
                    iconType="noitems-banking" />
            </OKSectionBox>
        );
    }

    buildSuccess(immAccount, immLoanModifyAssociatedAccount, immAccounts) {
        const immNewAccount = immAccounts.getIn(['byId', immLoanModifyAssociatedAccount.get('newAccountId')]);
        const oldAccount = immAccount.get('alias') + " " + getLastNChars(immAccount.get('iban'));
        const newAccount = immNewAccount.get('alias') + " " + getLastNChars(immNewAccount.get('iban'));
        const injectedStrings = [
            oldAccount,
            newAccount
        ]
        const successMessage = formatText('loanModifyAssociatedAccount-successMessage');
        const successSubMessage = formatText('loanModifyAssociatedAccount-successSubmessage', injectedStrings);
        const goBackButton = {
            label: <FormattedText value="loanModifyAssociatedAccount-goBackButton" format="uppercase" />,
            url: '/myprofile/loans-mortgages'
        };
        return (
            <WizardSuccess
                successMessage={successMessage}
                successSubMessage={successSubMessage}
                mainButton={goBackButton}
            />
        );
    }

    buildWizard(immLoan, immLoanModifyAssociatedAccount, immAccount, accountsList, accountsMap) {
        const { postModify, immAccounts, getBlockedAccounts } = this.props;
        const immSteps = immLoanModifyAssociatedAccount.get('steps');
        const actions = {
            setWillCancel: this.handleCancel,
            setVisibleStep: this.setVisibleStep,
            validateStep: this.validateStep,
            finish: postModify
        };

        return (
            <Wizard
                actions={actions}
                immSteps={immSteps}
                visibleStep={immLoanModifyAssociatedAccount.get('visibleStep')}
                fullWidth
                stepsAmount={immSteps.size}
                showPreLeaveModal
            >
                <WizardStep cancelButton>
                    <LoanModifyAssociatedAccountStep1
                        immAccount={immAccount}
                        getBlockedAccounts={getBlockedAccounts}
                        immLoan={immLoan}
                        immLoanModifyAssociatedAccount={immLoanModifyAssociatedAccount}
                        immAccounts={immAccounts}
                        accountsIndexes={accountsList}
                        onAccountChange={this.handleNewAccount}
                    />
                </WizardStep>
                <WizardStep
                    addLoadingBehaviour
                    position="last"
                    cancelButton
                    immFinalButton={'loanModifyAssociatedAccount-finishButtonLabel'}
                    isLoading={immLoanModifyAssociatedAccount.get('isFetching')}
                >
                    <LoanModifyAssociatedAccountStep2
                        immCurrentAccount={immAccount}
                        immLoan={immLoan}
                        immNewAccount={accountsMap.get(immLoanModifyAssociatedAccount.get('newAccountId'))}
                    />
                </WizardStep>
            </Wizard>
        )
    }

    handleCancel() {
        const { match: {params: { loanId }} } = this.props;
        this.props.history.push(`/myprofile/loans-mortgages/preapproved-loans/${loanId}`);
    }

    handleNewAccount(newAccountId) {
        this.props.setNewAccount({ newAccountId });
    }

    render() {
        const { match: {params: { loanId }}, immLoans, immLoanModifyAssociatedAccount, immAccounts } = this.props;
        const immLoan = immLoans.getIn(['byId', loanId], false);

        if (immLoan && !immLoan.get('isOldLoan') && !immLoan.get('isRestrictedLoan')) {
            const breadcrumbConfig = this.buildBreadcrum(immLoan);
            const immAccount = this.getCurrentAccount(immLoan, immAccounts);
            const accountsMap = immAccounts.get('byId');
            const tutorial = (
                <TutorialLauncher
                    type={GRAPHIC_TUTOR_TYPE_4}
                    title={formatText('tutorials-loansModifyAssociatedAccountTitle')}
                />
            );

            let bodyBlock;
            let accountsList;

            if (immLoanModifyAssociatedAccount.get('error')) {
                bodyBlock = this.buildError();
            } else if (immLoanModifyAssociatedAccount.get('submitSuccessful')) {
                bodyBlock = this.buildSuccess(immAccount, immLoanModifyAssociatedAccount, immAccounts);
            } else if (immAccount) {
                accountsList = this.getAccountsList(immAccounts.get('byOrder').toJS(), accountsMap, immAccount);

                if (accountsList.length === 0) {
                    bodyBlock = this.buildInsuficientAccounts();
                } else if (immLoanModifyAssociatedAccount.get('accountsInactive')) {
                    bodyBlock = this.buildInactiveAccounts(immLoan);
                } else if (accountsList.length > 0) {
                    bodyBlock = this.buildWizard(immLoan, immLoanModifyAssociatedAccount, immAccount, accountsList, accountsMap);
                }
            }

            return (
                <div className="loan-modify-associated-account-view">
                    <LoanHeader
                        immLoan={immLoan}
                        breadcrumbConfig={breadcrumbConfig}
                        title={'loanModifyAssociatedAccount-title'}
                        showDetails={false}
                        tutorial={tutorial}
                />
                    <div className="loan-modify-associated-account-view__body">
                        {bodyBlock}
                    </div>
                </div>
            );
        }

        return null;
    }
}

LoanModifyAssociatedAccountView.propTypes = {
    getCollectiveInfo: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immLoanModifyAssociatedAccount: PropTypes.object.isRequired,
    immLoans: PropTypes.object.isRequired,
    immSignaturePattern: PropTypes.object.isRequired,
    modifyFailure: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    postModify: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    setAccountsInactive: PropTypes.func.isRequired,
    setCurrentAccount: PropTypes.func.isRequired,
    setNewAccount: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    getBlockedAccounts: PropTypes.func
}

module.exports = withRouter(connect(
    state => ({
        immAccounts: state.accounts,
        immGlobalVariables: state.globalVariables,
        immLoanModifyAssociatedAccount: state.loanModifyAssociatedAccount,
        immLoans: state.loans,
        immSignaturePattern: state.signaturePattern,
    }), {
        getCollectiveInfo: collectiveActions.getCollectiveInfo,
        modifyFailure: loanModifyAssociatedAccountActions.simpleActions.loanModifyAssociatedAccountError,
        reset: loanModifyAssociatedAccountActions.simpleActions.loanModifyAssociatedAccountReset,
        setVisibleStep: loanModifyAssociatedAccountActions.simpleActions.loanModifyAssociatedAccountSetVisibleStep,
        setAccountsInactive: loanModifyAssociatedAccountActions.simpleActions.loanModifyAssociatedAccountInactive,
        setCurrentAccount: loanModifyAssociatedAccountActions.simpleActions.loanModifyAssociatedAccountSetCurrentAccount,
        setNewAccount: loanModifyAssociatedAccountActions.simpleActions.loanModifyAssociatedAccountSetNewAccount,
        validateStep: loanModifyAssociatedAccountActions.simpleActions.loanModifyAssociatedAccountValidateStep,
        postModify: loanModifyAssociatedAccountActions.postModify,
        getBlockedAccounts: blockedAccountsActions.getBlockedAccounts,
    }
)(LoanModifyAssociatedAccountView));
